/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./deleteStorage.defs.js";
export { main as default } from "./deleteStorage.defs.js";
